import { OrderbookStatePersistor } from '@/modules/marketplace/services/orderbook-state-persistor';
import { SavedViewsStore, makeUseSavedViews } from './saved-views-store';

// each store is lazily instantiated
// used by the different components of the feature
export const savedViewsRegistry = {
  orderbook: (): SavedViewsStore<OrderbookStatePersistor> =>
    makeUseSavedViews('orderbook', OrderbookStatePersistor)(),
};
